export default __webpack_public_path__ + "static/media/api.b4fbc1e9.svg";